import React, { FC, useState } from 'react'

import moment from 'moment/moment'

import { CardWrapper } from '../CardWrapper/CardWrapper'
import { CardItem } from '../CardItem/CardItem'
import { CardEmpty } from '../../empty/CardEmpty/CardEmpty'

import { getUserFullName } from '../../../../../../helpers/helpers'

import { CountryList } from '../../../../../../fakeData/countryList'

import { IUserInterface } from '../../../../../../models/users/user.interface'
import { useProfile } from '../../../../../../hooks/useProfile'

interface UserProfileCardProps {
  user: IUserInterface | null
  setUser?: (state: IUserInterface) => void
  isCollapsible?: boolean
  isEditable?: boolean
}

export const UserProfileCard: FC<UserProfileCardProps> = ({
  user,
  setUser,
  isCollapsible,
  isEditable,
}) => {
  const { onSaveEditUser, onCancelEditUser, onChangeUserInput } = useProfile()

  const [isEdit, setIsEdit] = useState(false)
  if (!user) return <CardEmpty />

  return (
    <CardWrapper
      isCollapsible={isCollapsible}
      title="Profile"
      onSaveEdit={() => onSaveEditUser({ user, setIsEdit })}
      onCancelEdit={() => onCancelEditUser({ user, setUser, setIsEdit })}
      isEditable={isEditable}
      isEdit={isEdit}
      setIsEdit={setIsEdit}
    >
      <CardItem
        fieldKey="userFullName"
        fieldType="text"
        label="Name"
        defaultValue={getUserFullName(user)}
        isEdit={isEdit}
        onChange={({ fieldName, fieldType, fieldKey, option }) =>
          onChangeUserInput({ fieldName, fieldType, fieldKey, option, user, setUser })
        }
      />
      <CardItem
        fieldKey="userNationality"
        fieldType="select"
        label="Nationality"
        defaultValue={
          CountryList.find((curr) => curr.value === user.userNationality)?.label || null
        }
        isEdit={isEdit}
        onChange={({ fieldName, fieldType, fieldKey, option }) =>
          onChangeUserInput({ fieldName, fieldType, fieldKey, option, user, setUser })
        }
      />
      <CardItem
        fieldKey="userDOB"
        fieldType="date"
        label="Date of Birth"
        defaultValue={user.userDOB ? moment(user.userDOB).format('D MMM, YYYY') : '-'}
        isEdit={isEdit}
        onChange={({ fieldName, fieldType, fieldKey, option }) =>
          onChangeUserInput({ fieldName, fieldType, fieldKey, option, user, setUser })
        }
      />
      <CardItem
        fieldKey="userPhoneNumber"
        fieldType="text"
        label="Phone"
        defaultValue={
          typeof user?.userPhoneNumber !== 'object' ? user.userPhoneNumber || null : null
        }
        isEdit={isEdit}
        onChange={({ fieldName, fieldType, fieldKey, option }) =>
          onChangeUserInput({ fieldName, fieldType, fieldKey, option, user, setUser })
        }
      />
      <CardItem fieldType="text" label="Email" defaultValue={user.userEmail} />
    </CardWrapper>
  )
}
